import { render, staticRenderFns } from "./FreightTableTruckIcon.vue?vue&type=template&id=60fe815b"
import script from "./FreightTableTruckIcon.vue?vue&type=script&lang=js"
export * from "./FreightTableTruckIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports